export class UpperLimit {
  /**
   * current
   */
  current: number;
  /**
   * number
   */
  item: number;
  /**
   * timetableId
   */
  timetableId: number;

  constructor(current?: number, item?: number, timetableId?: number) {
    this.current = current;
    this.item = item;
    this.timetableId = timetableId;
  }
}
